export default __webpack_public_path__ + "static/Katina-269e9d3d7f0fad2395994e22fc94f487146c989841181653bbbb062cbdcfcf9c.svg";